import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import { Order } from '../model/Order';

@Injectable()
export class OrdensalidaService {

  constructor(private http:HttpClient) {
  }

 /*obtiene todas las ordenes*/
  getAll(){
    let url = GLOBAL.url+`orders`;
    return this.http.get(url).map(res=>{
      return res;
    });
  }

 /*obtiene las ordenes que estan en estado pendiente*/
  getPendingOrders(){
    let url= GLOBAL.url+`orders?status_id=1&limit=1000`;
    return this.http.get(url).map(res=>{
      return res;
    });
  }

  /*obtiene las ordenes que estan aprobadas para pistolear*/
   getApprovatedOrders(){
     let url= GLOBAL.url+`orders?status_id=2&limit=1000`;
     return this.http.get(url).map(res=>{
       return res;
     });
   }

  /*obtiene las ordenes que estan en estado de revisión*/
  getRevisionOrders(){
    let url = GLOBAL.url+`orders?status_id=4&limit=1000`;
    return this.http.get(url).map(res=>{
      return res;
    });
  }

 /*crea una orden*/
  save(body){
    let url = GLOBAL.url+`orders`;
    return this.http.post(url,body).map( data => {
      return data;
    });
  }

 /*actualiza el estado de la orden a aprobado*/
  updateStateToApprovated(body, id){
    let url = GLOBAL.url+`orders/${id}/approve`;
    return this.http.put(url,body).map(res=>{
      return res;
    });
  }

  /*Elimina las cajas asociadas a la orden*/
   deleteTagsFromOrder(id,body){
     let url = GLOBAL.url+`orders/${id}/delete`;
     return this.http.put(url,body).map(res=>{
       return res;
     });
   }

  /*agrega un comentario a una orden*/
  addCommentaryOrder(body,id){
    let url = GLOBAL.url+`orders/${id}/messages`;
    return this.http.post(url,body).map(res=>{
      return res;
    });
  }

/*actualiza el estado de la orden a revisión*/
  updateStateToRevision(body,id){
    let url = GLOBAL.url+`orders/${id}/revision`;
    return this.http.put(url,body).map(res=>{
      return res;
    });
  }

  /*actualiza el estado de la orden a cerrada*/
    updateStateToClosed(body,id){
      let url = GLOBAL.url+`orders/${id}/close`;
      return this.http.put(url,body).map(res=>{
        return res;
      });
    }

  /*actualiza el estado de la orden a pre aprobado*/
    updateStateToPreApprovated(body,id){
      let url = GLOBAL.url+`orders/${id}/pre_approve`;
      return this.http.put(url,body).map(res=>{
        return res;
      });
    }

  /*obtiene una orden por me dio de la id*/
  getOne(id:number){
    let url=GLOBAL.url+`orders/`+id;
    return this.http.get(url).map(res=>{
      return res;
    });
  }

 /*obtiene las cajas asociadas a la orden (las cajas vienen agrupadas)*/
  getTagsOrder(id:number){
    let url = GLOBAL.url+`stock_summary?order_id=${id}&limit=10000`;
    return this.http.get(url).map(res=>{
      return res;
    });
  }

  /*obtiene las cajas asociadas a la orden (las cajas vienen agrupadas aunque se hayan eliminado o no las cajas)*/
   getTagsOrderDeleted(id:number){
     let url = GLOBAL.url+`stock_summary?order_id=${id}&deleted=1&limit=10000`;
     return this.http.get(url).map(res=>{
       return res;
     });
   }

  /*obtiene ordenes con respecto a los filtros enviados*/
  getDataFiltered(filters){
    let url = GLOBAL.url+`orders`+filters;
    return this.http.get(url).map(res=>{
      return res;
    });
  }

  transformData(data:any){
    /*id,status_id,reason_id,area_id,user_id,approver_id,approve_date,receptor_id,reception_date*/
    let order = new Order('-1','1',data.reason_id,'','','','','','',data.client_id);
    console.log("ORDEN: ", order);
    return order.getJson();
  }

  transformDataUpdateStatusToApprovated(id:number){
    let order = new Order(id,0,0,0,0,0,0,0,0,0);
    return order.getJsonUpdateStatusToApprovated();
  }

  transformDataUpdateStatusToRevision(id:number){
    let order = new Order(id,0,0,0,0,0,0,0,0,0);
    return order.getJsonUpdateStatusToRevision();
  }

  transformDataCommentaryOrder(message){
    let order = new Order(0,0,0,0,0,0,0,0,0,0);
    return order.getJsonCommentaryOrder(message);
  }

  transformDataUpdateStatusToPreApprovated(id:number){
    let order = new Order(id,0,0,0,0,0,0,0,0,0);
    return order.getJsonUpdateStatusToPreApprovated();
  }

  transformDataUpdateStatusToClosed(id:number){
    let order = new Order(id,0,0,0,0,0,0,0,0,0);
    return order.getJsonUpdateStatusToClosed();
  }

  transformDataDeleteAllTags(tags:any,id_order:number){
    let order = new Order(id_order,0,0,0,0,0,0,0,0,0);
    return order.getJsonDeleteAllTags(tags,id_order);
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/ordensalida.service.ts